import type { DocumentChunk } from './DocumentChunk';

export type BuyerSimulationBidResponse = {
  id: number;
  title: string;
  buyerName: string;
  extractionStatus: CriteriaExtractionStatus;

  additionalContext?: string;
  compagnyRelationWithBuyer?: string;
  workspaceBuyerSimResponseStrategy?: string;

  buyerSimProposalVersions?: BuyerSimProposalVersion[];
  buyerSimJudgementCriteria: BuyerSimJudgementCriterion[];

  createdAt: string;
  updatedAt: string;
};

export type BuyerSimCriteriaColor = {
  color?: 'teal' | 'blue' | 'orange' | 'violet';
  shade?: 1 | 3 | 6 | 9;
};

export type BuyerSimJudgementCriterion = {
  id: number;
  title: string;
  weight: number;
  color?: BuyerSimCriteriaColor;

  buyerSimBidResponseId: number;
  parentId?: number | null;
};

export enum CriteriaExtractionStatus {
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  DONE = 'DONE',
  FAILED = 'FAILED',
}

export type BuyerSimProposalVersion = {
  id: number;
  version: string;
  buyerSimBidResponseId: number;
  buyerSimProposalDocs: BuyerSimResponseDocument[];
  buyerSimRequirementEvaluations?: BuyerSimRequirementEvaluation[];

  extractionStatus: CriteriaExtractionStatus;
};

type BuyerSimResponseDocument = {
  id: number;
  originalName: string;
  S3FileURL: string;
  type: BuyerSimResponseDocType;
};

export enum BuyerSimResponseDocType {
  'SPECIFICATION_RC' = 'SPECIFICATION_RC',
  'SPECIFICATION_DCE' = 'SPECIFICATION_DCE',
  'PROPOSAL_TECHNICAL_SUBMISSION' = 'PROPOSAL_TECHNICAL_SUBMISSION',
  'PROPOSAL_APPENDICES' = 'PROPOSAL_APPENDICES',
}

export type BuyerSimRequirementEvaluation = {
  id: number;
  retrievedAnswerFromProposal?: string | null;
  sources?: DocumentChunk[];
  extractionStatus: CriteriaExtractionStatus;
  buyerSimBidRequirement: BuyerSimBidRequirement;
};

export type BuyerSimBidRequirement = {
  id: number;
  title: string;
  source: DocumentChunk;
  chunkIndex?: number | null;
  llmRephrasedQuestion: string;
  buyerSimJudgementCriterionId?: number | null;

  buyerSimBidResponseId: number;
};

export type BuyerSimulationMinimalBidResponse = Omit<
  BuyerSimulationBidResponse,
  | 'additionalContext'
  | 'compagnyRelationWithBuyer'
  | 'workspaceBuyerSimResponseStrategy'
>;
